// Avatar with initials fallback. Resolves relative asset URLs against the API base.
import { api } from "../../api/client.js";
import { cn } from "@/lib/utils";
import { gradientFor } from "./format.js";

export interface AvatarProps {
  src: string | null | undefined;
  name: string;
  size?: number;
  className?: string;
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

function resolve(src: string): string {
  if (/^(https?:|data:|blob:)/.test(src)) return src;
  return api.url(src);
}

export function Avatar({ src, name, size = 32, className }: AvatarProps) {
  if (src) {
    return (
      <img
        src={resolve(src)}
        alt={name}
        width={size}
        height={size}
        className={cn(
          "shrink-0 rounded-full border border-white/10 object-cover",
          className,
        )}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      aria-label={name}
      className={cn(
        "inline-flex shrink-0 select-none items-center justify-center rounded-full",
        "border border-white/10 font-semibold text-white/90",
        className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.floor(size * 0.38)),
        backgroundImage: gradientFor(name),
      }}
    >
      {initialsOf(name)}
    </span>
  );
}
